import { Navigate, Route, Routes } from 'react-router';
import { selectCurrentUser } from './redux/slices/authSlice';
import { useSelector } from 'react-redux';
import AuthLogin from './pages/Layout/AuthLogin';
import Landing from './pages/Landing';
import PrivateLayout from './pages/Layout/PrivateLayout';

const ProtectedRoute = ({ user }: any) => {
    return user ? <PrivateLayout user={user} /> : <Navigate to="/autenticacion-usuario" replace />;
};

function App() {
    const user = useSelector(selectCurrentUser);

    return (
        <Routes>
            <Route path="/autenticacion-usuario" element={<Landing />} />
            <Route path="/auth/callback" element={<AuthLogin />} />
            <Route path="/app/*" element={<ProtectedRoute user={user} />} />
            <Route index path="/" element={<Navigate to="/autenticacion-usuario" replace />} />
        </Routes>
    );
}

export default App;
